import {Dispatch, memo, SetStateAction, useMemo} from 'react';

import {debounce} from 'lodash';

import VerificationForm from '~/shared/components/VerificationForm';
import {trackEvent} from '~/shared/services/analytics';
import {VerificationFormContextProvider} from '~/common/contextProviders/VerificationFormContextProvider';
import {getLocalizationService} from '~/shared/services/localisationService';

import {LOGIN_PROVIDER_ANALYTICS_MAP, LoginProvider} from './consts';

type LoginVerificationFormProps = {
  onSubmitVerification: ({authenticationCode}: {authenticationCode?: string}) => void;
  emailEntry: string;
  verificationDetails: {
    isPhoneMethod: boolean;
  };
  onSubmitEmail: ({email, shouldSendTrackEvent}: {email: string; shouldSendTrackEvent?: boolean}) => void;
  resErrors: string | null;
  setResErrors: Dispatch<SetStateAction<string | null>>;
  loginProvider: LoginProvider;
  fromCheckout?: boolean;
};

const LoginVerificationForm = ({
  onSubmitVerification,
  emailEntry,
  verificationDetails,
  onSubmitEmail,
  resErrors,
  setResErrors,
  fromCheckout,
  loginProvider,
}: LoginVerificationFormProps) => {
  const {t} = getLocalizationService();
  const linkType = verificationDetails.isPhoneMethod ? '2FA - SMS' : '2FA - Email';

  const reSendCode = useMemo(() => {
    return debounce(() => {
      trackEvent('hasClickedSendCodeAgain', {linkType, onCheckout: fromCheckout, authenticationProvider: LOGIN_PROVIDER_ANALYTICS_MAP[loginProvider]});
      onSubmitEmail({email: emailEntry, shouldSendTrackEvent: false});
    }, 500);
  }, [emailEntry, fromCheckout, linkType, loginProvider, onSubmitEmail]);

  return (
    <>
      <VerificationFormContextProvider>
        <VerificationForm
          onReSendCode={reSendCode}
          onSubmit={onSubmitVerification}
          email={emailEntry}
          headerText={t('a_verification_code_was_sent_to_your_registered_phone_or_email')}
          resErrors={resErrors}
          setResErrors={setResErrors}
        />
      </VerificationFormContextProvider>
    </>
  );
};

export default memo(LoginVerificationForm);
